<style scoped>
.excel-span {
  height: 24px;
  line-height: 24px;
  display: inline-block;
  padding: 1px 8px 1px 8px;
  border-radius: 4px;
  background-color: #f4f4f5;
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
</style>
<template>
  <div>
    <el-dialog :visible.sync="visible" :title="title" append-to-body="append-to-body">
      <div :class="[tableData.length > 0 ? 'dialog-scroller' : '']" style="display: flex;flex-direction: column;">
        <el-form size="mini" :inline="true" :model="conditions" class="demo-form-inline">
          <el-form-item :label="$t('qingxuanzeshebei')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="conditions.equipmentIdList"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button :loading="exportLoading" size="mini" icon="el-icon-document-add" type="primary" @click="exportWorkOrder">
              {{ $t('daochugongdan') }}
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button :loading="uploadLoading" size="mini" type="default" icon="el-icon-plus" @click="handleUpload">
              {{ $t('piliangshangchuan') }}
            </el-button>
          </el-form-item>
        </el-form>
        <!--上传-->
        <div>
          <input id="matterFileInput" ref="excel-upload-input" class="excel-upload-input" type="file" multiple accept=".xlsx, .xls" @change="handleClick" />
        </div>
        <!--excel-->
        <div>
          <span v-for="(item, index) in excel" :key="index" class="excel-span" closable size="mini">
            <i class="el-icon-link" />
            <span>{{ item }}</span>
            <i style="margin-left: 5px" class="el-icon-close" @click="deleteExcel(item)" />
          </span>
        </div>
        <!--表格-->
        <div ref="table" style="flex: 1;margin-top: 10px;">
          <el-table stripe :max-height="tableHeight" :data="tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)" border size="mini" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
            <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop" :show-overflow-tooltip="true" :label="item.label" :width="item.width" :sortable="item.sortable">
              <template slot-scope="scope">
                <span>{{ scope.row[item.prop] === '' ? '-' : scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 20px;">
          <el-pagination v-if="tableData.length > 0" style="display: flex;float: right;" background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :pagerCount="5" :page-size="pagination.pageSize" layout="total,sizes,prev,pager,next" :total="tableData.length" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="visible = false">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" size="mini" :loading="saveLoading" @click="importData" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-批量调整' } }">{{ $t('baocun') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saveLoading: false,
      exportLoading: false,
      uploadLoading: false,
      excel: [],
      tableHeight: 0,
      tableData: [],
      tableColumn: [
        {
          label: this.$t('daorubaogao'),
          prop: 'result',
          width: 125
        },
        {
          label: this.$t('shengchangongdanhao'),
          prop: 'no',
          width: 150
        },
        {
          label: this.$t('shengchandingdanfenluid'),
          prop: 'orderEntryId',
          width: 150
        },
        {
          label: this.$t('shebeimingcheng'),
          prop: 'equipmentName',
          width: 150
        },
        {
          label: this.$t('huohao'),
          prop: 'articleNumber',
          width: 150
        },
        {
          label: this.$t('wuliaomingcheng'),
          prop: 'materialName',
          width: 150
        },
        {
          label: this.$t('mojumingcheng'),
          prop: 'mouldName',
          width: 150
        },
        {
          label: this.$t('renwudanzhongliang(KG)'),
          prop: 'weight',
          width: 150
        },
        {
          label: this.$t('danzhong(G)'),
          prop: 'singleWeight',
          width: 150
        },
        {
          label: this.$t('shijimoqiangshu'),
          prop: 'actualCavity',
          width: 150
        },
        {
          label: this.$t('beizhu'),
          prop: 'remark'
        }
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      visible: false,
      title: this.$t('piliangtiaozheng'),
      conditions: {
        equipmentIdList: []
      }
    };
  },
  watch: {
    show: {
      handler(n) {
        this.visible = n;
        if (n == true) {
          this.countTableHeight();
        }
        if (n == false) {
          this.currentPage = 1;
        }
      },
      immediate: false
    },
    visible: {
      handler(n) {
        if (!n) {
          this.$emit('update:show', false);
          this.tableData = [];
          this.excel = [];
          this.conditions.equipmentIdList = [];
          this.$refs['excel-upload-input'].value = null;
        }
      },
      immediate: false
    }
  },
  methods: {
    // 导出工单
    exportWorkOrder() {
      // if (this.conditions.equipmentIdList.length === 0) {
      //   return this.$message.warning(this.$t('qingxuanzeshebei'));
      // }
      this.exportLoading = true;
      this.http
        .post('/web/production/wo/export', this.conditions)
        .then(result => {
          const fileId = result.data;
          if (!fileId) {
            this.$message.error(this.$t('cishebeiwugongdan'));
            return;
          }
          this.http
            .get('/web/customer/files/download?id=' + fileId)
            .then(res => {
              let baseUrl = res.data;
              if (baseUrl) {
                window.open(baseUrl);
              } else {
                this.$message.error(this.$t('wenjianlianjieweikong'));
              }
            })
            .catch(err => {
              this.$message.error(err);
            })
            .finally(() => {
              this.exportLoading = false;
            });
        })
        .catch(err => {
          this.$message.error(err);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    importData() {
      const data = this.deepClone([...this.tableData]);
      if (data.length <= 0) {
        this.$message.warning(this.$t('qingshangchuanwenjian'));
        return;
      }
      this.saveLoading = true;
      for (let i = 0; i < data.length; i++) {
        data[i]['no'] ? data[i]['no'] : (data[i]['no'] = '');
        data[i]['orderEntryId'] ? data[i]['orderEntryId'] : (data[i]['orderEntryId'] = '');
        data[i]['equipmentName'] ? data[i]['equipmentName'] : (data[i]['equipmentName'] = '');
        data[i]['articleNumber'] ? data[i]['articleNumber'] : (data[i]['articleNumber'] = '');
        data[i]['materialName'] ? data[i]['materialName'] : (data[i]['materialName'] = '');
        data[i]['mouldName'] ? data[i]['mouldName'] : (data[i]['mouldName'] = '');
        data[i]['weight'] ? data[i]['weight'] : (data[i]['weight'] = '');
        data[i]['singleWeight'] ? data[i]['singleWeight'] : (data[i]['singleWeight'] = '');
        data[i]['actualCavity'] ? data[i]['actualCavity'] : (data[i]['actualCavity'] = '');
        data[i]['remark'] ? data[i]['remark'] : (data[i]['remark'] = '');
        delete data[i]['excel'];
      }
      if (this.listLength == null || this.listLength.length == 0) {
        return this.http
          .post('/web/production/wo/batchImport?onlyValidate=false', data)
          .then(res => {
            this.$message.success(this.$t(res.msg));
            this.show = false;
            // 刷新主页面列表(参数要与被调用得页面$on()中名称对应)
            this.utils.event_hub.$emit('WEB_WORK_ORDER_EXECUTION_REFRESH');
          })
          .catch(error => {
            this.$message.error(error);
          })
          .finally(() => {
            this.saveLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
        this.saveLoading = false;
      }
    },
    /**
     * 显示上传弹框
     */
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    /**
     * 点击上传
     * @param e
     * @returns {Promise<void>}
     */
    async handleClick(e) {
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        this.beforeUpload(files[i]);
      }

      this.uploadLoading = true;
      document.getElementById('matterFileInput').value = '';
      setTimeout(() => {
        let data = [...this.tableData];
        for (let i = 0; i < data.length; i++) {
          data[i]['no'] ? data[i]['no'] : (data[i]['no'] = '');
          data[i]['orderEntryId'] ? data[i]['orderEntryId'] : (data[i]['orderEntryId'] = '');
          data[i]['equipmentName'] ? data[i]['equipmentName'] : (data[i]['equipmentName'] = '');
          data[i]['articleNumber'] ? data[i]['articleNumber'] : (data[i]['articleNumber'] = '');
          data[i]['materialName'] ? data[i]['materialName'] : (data[i]['materialName'] = '');
          data[i]['mouldName'] ? data[i]['mouldName'] : (data[i]['mouldName'] = '');
          data[i]['weight'] ? data[i]['weight'] : (data[i]['weight'] = '');
          data[i]['singleWeight'] ? data[i]['singleWeight'] : (data[i]['singleWeight'] = '');
          data[i]['actualCavity'] ? data[i]['actualCavity'] : (data[i]['actualCavity'] = '');
          data[i]['remark'] ? data[i]['remark'] : (data[i]['remark'] = '');
          delete data[i]['excel'];
        }
        this.http
          .post('/web/production/wo/batchImport?onlyValidate=true', data)
          .then(response => {
            this.listLength = response.data;
            if (response.data && response.data.length > 0) {
              const list = response.data;
              for (let i = 0; i < list.length; i++) {
                this.$set(this.tableData[Number(list[i]['index'])], 'result', list[i]['items'].join(','));
              }
            }
          })
          .catch(err => {
            this.$message.error(err);
          })
          .finally(() => {
            this.uploadLoading = false;
          });
      }, 800);
    },
    /**
     * 上传前
     * @param rawFile
     * @returns {boolean}
     */
    beforeUpload(rawFile) {
      if (this.excel.length < 2) {
        //this.$refs['excel-upload-input'].value = null
      }
      if (!this.isExcel(rawFile)) {
        this.$message.error(this.$t('zhizhichi') + '.xlxs,xls,csv' + this.$t('geshiwenjian'));
        return false;
      }
      if (this.excel.length > 2) {
        this.$message.error(this.$t('zuidazhichi') + '3' + this.$t('geexcelwenjian'));
        return false;
      }
      if (this.excel.includes(rawFile.name)) {
        this.$message.error(rawFile.name + this.$t('wenjianyicunzai'));
        return false;
      }
      this.readerData(rawFile);
    },

    /**
     * 解析excel
     * @param rawFile
     */
    readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = e => {
        const name = rawFile.name;
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: 'array'
        });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const header = this.getHeaderRow(worksheet);
        const results = XLSX.utils.sheet_to_json(worksheet);
        this.generateData({
          header,
          results,
          name
        });
      };
      reader.readAsArrayBuffer(rawFile);
    },
    /**
     * 获取excel头部
     * @param sheet
     * @returns {[]}
     */
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet['!ref']);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell =
          sheet[
          XLSX.utils.encode_cell({
            c: C,
            r: R
          })
          ];
        let hdr = 'UNKNOWN ' + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * 数据解析
     * @param header
     * @param results
     * @param name
     */
    generateData({ header, results, name }) {
      const data = [];
      if (results.length > 0) {
        for (let i = 0; i < results.length; i++) {
          const item = {
            excel: name
          };
          for (let j = 0; j < this.tableColumn.length; j++) {
            if (results[i][this.tableColumn[j]['label']]) {
              this.$set(item, this.tableColumn[j]['prop'], results[i][this.tableColumn[j]['label']]);
            }
          }
          // 过滤多余的表头
          if (item.no === '生产工单号') {
            continue;
          }
          // 类型字段转整型
          //item['type'] = parseInt(item['type'])
          // if (Number.isNaN(item['type'])) {
          // 	item['type'] = ''
          // }
          data.push(item);
        }
      }
      this.tableData = this.tableData.concat(data);
      for (let i = 0; i < this.tableData.length; i++) {
        this.$set(this.tableData[i], 'rid', i + 1);
      }
      this.excel.push(name);
      this.countTableHeight();
    },
    /**
     * 判断是否为excel文件
     * @param file
     * @returns {boolean}
     */
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    },
    /**
     * 刪除excel
     * @param name
     */
    deleteExcel(name) {
      this.excel = this.excel.filter(item => {
        return item !== name;
      });
      this.tableData = this.tableData.filter(item => {
        return item.excel !== name;
      });
      console.log('excel:', this.excel);
      console.log('tableData:', this.tableData);
      console.log('tableColumn', this.tableColumn);
    },
    countTableHeight() {
      this.tableHeight = 0;
      this.$nextTick(() => {
        if (this.tableData.length > 0) {
          this.tableHeight = this.$refs.table.offsetHeight - 10;
        } else {
          this.tableHeight = 110;
        }
      });
    },
    //深拷贝
    deepClone(data) {
      const type = this.judgeType(data);
      let obj;
      if (type === 'array') {
        obj = [];
      } else if (type === 'object') {
        obj = {};
      } else {
        // 不再具有下一层次
        return data;
      }
      if (type === 'array') {
        // eslint-disable-next-line
        for (let i = 0, len = data.length; i < len; i++) {
          obj.push(this.deepClone(data[i]));
        }
      } else if (type === 'object') {
        // 对原型上的方法也拷贝了....
        // eslint-disable-next-line
        for (const key in data) {
          obj[key] = this.deepClone(data[key]);
        }
      }
      return obj;
    },
    judgeType(obj) {
      // tostring会返回对应不同的标签的构造函数
      const toString = Object.prototype.toString;
      const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',

        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
      };
      if (obj instanceof Element) {
        return 'element';
      }
      return map[toString.call(obj)];
    }
  }
};
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}

.drop {
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
